import axios, { AxiosResponse } from "axios";

export interface ICategoria {
  id? : number
  nome: string;
  cor?: string
}

export async function getCategorias(): Promise<AxiosResponse<ICategoria[]>> {
  return axios.get("/programacategoria");
}
export async function getCategoria(
  id: number | string,
): Promise<AxiosResponse<ICategoria>> {
  return axios.get(`/programacategoria/${id}`);
}
export async function createCategoria(
  categoria: ICategoria,
): Promise<AxiosResponse<ICategoria>> {
  console.log(categoria)
  return axios.post("/programacategoria", { nome: categoria.nome, cor: categoria.cor });
}
export async function updateCategoria(
  id: number | string,
  nome: string,
  cor: string
): Promise<AxiosResponse<void>> {
  return axios.put(`/programacategoria/${id}`, { nome: nome, cor: cor });
}
export async function deleteCategoria(
  id: number | string,
): Promise<AxiosResponse<void>> {
  return axios.delete(`/programacategoria/${id}`);
}
